// IMPORTANT: THIS FILE IS AUTO GENERATED
/* tslint:disable */
export const APP_VERSION = {
    "dirty": false,
    "raw": "2b9115d",
    "hash": "2b9115d",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "2b9115d",
    "semverString": null,
    "version": "1.172.1"
};
/* tslint:enable */
